import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter, orderBy } from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import HelpIcon from '@material-ui/icons/Help';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MoreIcon from '@material-ui/icons/MoreVert';
import Drawer from '@material-ui/core/Drawer';
import enhance from './AuthHeader.enhancer';
import NavLinkList from './NavLinkList';
import { Grid, Typography } from '@material-ui/core';
import Autosuggest from 'react-autosuggest';
import Popover from '@material-ui/core/Popover';
import Divider from '@material-ui/core/Divider';
import { dealStatuses } from '../../constants';
import moment from 'moment';

class AuthHeader extends Component {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null,
    drawerIsOpen: false,
    searchValue: '',
    notificationsPopoverOpen: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile && nextProps.profile.isLoaded) {
      const pathName = this.props.history.location.pathname;
      // if the user got a new message (number of messages changes) and the user is currently
      // on the messages page, update unread messages back to 0
      if (pathName === '/messages' && nextProps.profile.unReadMessages > 0) {
        this.props.resetUnreadMessagesHandler();
      }
    }
  }

  navigateToProfile = () => {
    this.handleMenuClose();
    this.props.history.push(`/user/${this.props.auth.uid}/profile`);
  };

  navigateToSettings = () => {
    this.handleMenuClose();
    this.props.history.push(`/settings`);
  };

  handleProfileMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleLogout = () => {
    this.props.logOut();
    this.handleMenuClose();
  };
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  handleMobileMenuOpen = event => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };

  openMenuDrawer = () => {
    this.setState({ ...this.state, drawerIsOpen: true });
  };

  closeMenuDrawer = () => {
    this.setState({ ...this.state, drawerIsOpen: false });
  };

  onSearchChange = (event, { newValue }) => {
    this.setState({
      searchValue: newValue
    });
  };

  renderSuggestion = suggestion => (
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => this.navigateToUserProfile(suggestion.id)}
    >
      {suggestion.displayName}
    </div>
  );

  navigateToUserProfile = id => {
    this.setState({
      ...this.state,
      searchValue: ''
    });
    this.props.history.push(`/user/${id}/profile`);
  };

  getSuggestionValue = suggestion => suggestion.displayName;

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    console.log('got up in here');
    this.props.searchUsersHandler(value, this.props.profile.isCompany);
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [{ displayName: 'test' }]
    });
  };

  getSearchPlaceholder = profile => {
    let searchPlaceholder = '';
    if (profile.isLoaded) {
      searchPlaceholder = profile.isCompany
        ? 'Search Influencers…'
        : 'Search Companies…';
    }
    return searchPlaceholder;
  };

  handleMessageIconClick = () => {
    this.props.resetUnreadMessagesHandler();
    this.props.history.push(`/messages`);
  };

  openNotificationsPopup = event => {
    this.props.resetNotificationsHandler();
    this.setState({
      ...this.state,
      notificationsPopoverOpen: true,
      notificationsPopoverOpen: event.target
    });
  };

  closeNotificationsPopup() {
    this.setState({
      ...this.state,
      notificationsPopoverOpen: false,
      notificationsPopoverOpen: null
    });
  }

  handleNotificationClick(link) {
    this.props.history.push(link);
  }

  render() {
    const {
      anchorEl,
      mobileMoreAnchorEl,
      searchValue,
      notificationsPopoverOpen
    } = this.state;
    const { classes, profile, searchResults, notifications } = this.props;
    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={this.handleMenuClose}
      >
        <MenuItem onClick={this.navigateToProfile}>Profile</MenuItem>
        <MenuItem onClick={this.navigateToSettings}>My Account</MenuItem>
        <a
          href="https://help.hypepilot.com"
          target="_blank"
          className={classes.help}
        >
          <MenuItem>Help</MenuItem>
        </a>
        <MenuItem onClick={this.handleLogout}>Log Out</MenuItem>
      </Menu>
    );

    const renderMobileMenu = (
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMobileMenuOpen}
        onClose={this.handleMenuClose}
      >
        <MenuItem onClick={this.handleMessageIconClick.bind(this)}>
          <IconButton color="inherit">
            <Badge badgeContent={profile.unReadMessages} color="secondary">
              <MailIcon />
            </Badge>
          </IconButton>
          <p>Messages</p>
        </MenuItem>
        <MenuItem onClick={this.openNotificationsPopup.bind(this)}>
          <IconButton color="inherit">
            <Badge
              badgeContent={
                notifications
                  ? notifications.filter(not => !not.read).length
                  : 0
              }
              color="secondary"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <p>Notifications</p>
        </MenuItem>
        <MenuItem onClick={this.navigateToProfile}>
          <IconButton color="inherit">
            <AccountCircle />
          </IconButton>
          <p>Profile</p>
        </MenuItem>
        <MenuItem onClick={this.navigateToSettings}>
          <IconButton color="inherit">
            <SettingsApplicationsIcon />
          </IconButton>
          <p>My Account</p>
        </MenuItem>
        <MenuItem>
          <IconButton color="inherit">
            <HelpIcon />
          </IconButton>
          <a
            href="https://help.hypepilot.com"
            target="_blank"
            className={classes.help}
          >
            <p>Help</p>
          </a>
        </MenuItem>
        <MenuItem
          onClick={this.handleProfileMenuOpen}
          onClick={this.handleLogout}
        >
          <IconButton color="inherit">
            <ExitToAppIcon />
          </IconButton>
          <p>Log Out</p>
        </MenuItem>
      </Menu>
    );

    return (
      <React.Fragment>
        <div className={classes.root}>
          <AppBar
            position="static"
            color="white"
            className={
              profile.signUpComplete || profile.signUpComplete === undefined
                ? classes.appBar
                : classes.hiddenAppbar
            }
          >
            <Toolbar className={classes.toolBar}>
              <div
                className={
                  profile.signUpComplete || profile.signUpComplete === undefined
                    ? ''
                    : classes.appbarOverlay
                }
              ></div>
              <IconButton
                className={classes.menuButton}
                color="inherit"
                aria-label="Open drawer"
                onClick={() => this.openMenuDrawer()}
              >
                <MenuIcon />
              </IconButton>

              <Drawer
                open={this.state.drawerIsOpen}
                onClose={() => this.closeMenuDrawer()}
                className={classes.drawer}
                classes={{
                  paper: classes.drawerPaper
                }}
                anchor="left"
              >
                <div
                  className={classes.menuList}
                  onClick={() => this.closeMenuDrawer()}
                  onKeyDown={() => this.closeMenuDrawer()}
                >
                  <NavLinkList />
                </div>
              </Drawer>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <Autosuggest
                  className={classes.searchBox}
                  suggestions={searchResults}
                  // suggestions={[{displayName: 'something'}, {displayName: 'abc'}]}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={{
                    placeholder: this.getSearchPlaceholder(profile),
                    value: searchValue,
                    onChange: this.onSearchChange.bind(this)
                  }}
                  theme={{
                    // input: classes.searchBox,
                    input: classes.reactAutosuggestInput,
                    container: classes.reactAutosuggestContainer,
                    inputFocused: classes.reactAutosuggestInputFocused,
                    inputOpen: classes.reactAutosuggestInputOpen,
                    suggestionsContainer:
                      classes.reactAutosuggestSuggestionsContainer,
                    suggestionsContainerOpen:
                      classes.reactAutosuggestSuggestionsContainerOpen,
                    suggestionsList: classes.reactAutosuggestSuggestionsList,
                    suggestion: classes.ReactAutosuggestSuggestion,
                    suggestionHighlighted:
                      classes.reactAutosuggestSuggestionHighlighted
                  }}
                />
              </div>
              <div className={classes.grow} />
              <div className={classes.sectionDesktop}>
                <IconButton
                  color="inherit"
                  onClick={this.handleMessageIconClick.bind(this)}
                >
                  <Badge
                    badgeContent={profile.unReadMessages}
                    color="secondary"
                  >
                    <MailIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  color="inherit"
                  onClick={this.openNotificationsPopup.bind(this)}
                >
                  <Badge
                    badgeContent={
                      notifications
                        ? notifications.filter(not => !not.read).length
                        : 0
                    }
                    color="secondary"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleProfileMenuOpen}
                  color="inherit"
                >
                  {!profile.profilePictureUrl && <AccountCircle />}
                  <img
                    src={profile.profilePictureUrl}
                    className={classes.circleImage}
                  />
                </IconButton>
              </div>
              <div className={classes.sectionMobile}>
                <IconButton
                  aria-haspopup="true"
                  onClick={this.handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          {renderMenu}
          {renderMobileMenu}
          <Popover
            // className={classes.popover}
            open={notificationsPopoverOpen}
            anchorEl={notificationsPopoverOpen}
            onClose={this.closeNotificationsPopup.bind(this)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <div className={classes.popover}>
              {notifications &&
                notifications.length > 0 &&
                orderBy(notifications, ['timestamp'], ['desc']).map(
                  notification => {
                    return (
                      <React.Fragment>
                        <Grid
                          className={classes.notificationGrid}
                          onClick={() =>
                            this.handleNotificationClick(notification.link)
                          }
                        >
                          <Typography className={classes.notificationDate}>
                            {moment(notification.timestamp.toDate()).format(
                              'MM/DD/YYYY'
                            )}
                          </Typography>
                          <Typography>{notification.message}</Typography>
                        </Grid>
                        <Divider />
                      </React.Fragment>
                    );
                  }
                )}
              {(!notifications || notifications.length <= 0) && (
                <Grid
                  className={classes.notificationGrid}
                  align="center"
                  justify="center"
                >
                  <Typography align="center" justify="center">
                    No notifications
                  </Typography>
                </Grid>
              )}
            </div>
          </Popover>
        </div>
      </React.Fragment>
    );
  }
}

AuthHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

export default enhance(AuthHeader);



// WEBPACK FOOTER //
// ./src/components/layout/AuthHeader.js